import { render, staticRenderFns } from "./LoginMobile.vue?vue&type=template&id=6078456a&scoped=true"
import script from "./LoginMobile.vue?vue&type=script&lang=js"
export * from "./LoginMobile.vue?vue&type=script&lang=js"
import style0 from "./LoginMobile.vue?vue&type=style&index=0&id=6078456a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6078456a",
  null
  
)

export default component.exports